module.exports = __webpack_public_path__ + "img/coolant-temp.8a05050a.svg";